<template>

    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-xl-offset-4">

                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <center>
                                <img :src="$root.config.url + '/images/logo.png'" style="width: 200px;">
                            </center>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>

export default {
    name:                           'Inicio',
    components: {
    },       
    data () {
        var self                    = this;
        return {
            form: {
                "_cod":             self.$root.user.cod,
            }            
        }
    },
    methods: {
        
    },    
    created: function() {
        var self = this;
    },     
    mounted: function() {
        loading.hide();  
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue